import { ServiceCreate } from "@/features/clinician/services/components/service-create";

const CreateServices = () => {
    return (
        <>
            <div className="px-4 py-8">
                <div className="container mx-auto">
                    <h1 className="mb-4 text-2xl font-semibold">
                        Your services
                    </h1>
                    <ServiceCreate />
                </div>
            </div>
        </>
    );
};

export default CreateServices;
